import React, { useEffect, useMemo, useState } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
//import { ReactComponent as InfoIcon } from '../images/info-icon.svg'
import PageHeader from '../components/PageHeader';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, openModal, setAmount, setAmountData, setBreakpoints, setIsChecked, setPageError } from '../lib/features/amountSlice';
import { useGetAmountSelectionMutation, useGetCustomerDetailsMutation, useSubmitAmountSelectionMutation } from '../lib/services/eligibilityApi';
import { useLocation, useNavigate } from 'react-router-dom';
import CenteredPopup from '../components/popups/CenteredPopup';
import { formatCurrency } from '../lib/middleware/currencyFormatter';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { clevertapIdentitySet, pushCleverTapEvent } from "../lib/middleware/CtEvents";
import VkycCard from '../components/VkycCard';
// import { useGetCkycSearchMutation } from '../lib/services/kycApi';

function AmountRequired() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [getAmountSelection] = useGetAmountSelectionMutation();
    const [getCustomerDetails] = useGetCustomerDetailsMutation();
    // const [getCkycSearch] = useGetCkycSearchMutation();
    const [submitAmountSelection, { isLoading }] = useSubmitAmountSelectionMutation()
    const [tapClick] = useTapClickMutation()
    const { amount, isChecked, isModalOpen, pageerror, amountdata, breakpoints } = useSelector((state) => state.amount)
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const [btnDisable, setBtnDisable] = useState(true)

    const handleClose = () => {
        dispatch(closeModal(false));
        dispatch(setPageError(''))
    }
    const modalButtons = [
        { label: 'Close', onClick: handleClose }
    ]

    const calculateEMI = (principal, roi, tenure) => {
        const emi = principal * ((roi * Math.pow(1 + roi, tenure)) / (Math.pow(1 + roi, tenure) - 1));
        return emi.toFixed(0);
    }

    const handleSliderChange = (e) => {
        const value = Number(e.target.value);
        const max = breakpoints.indexOf(parseInt(amountdata.approved_amount));
        const percentage = (value / max) * 100;
        e.target.style.background = `linear-gradient(to right, #AA013F ${percentage}%, #D9D9D9 ${percentage}%)`;
        dispatch(setAmount(breakpoints[value]));
        const finalRoi = parseInt(amountdata.roi) ? parseInt(amountdata.roi) : 2
        const emi = calculateEMI(parseInt(breakpoints[value]), parseInt(finalRoi) / 100, parseInt(amountdata.tenure))
        dispatch(setAmountData({ ...amountdata, emi_amount: parseInt(emi) }))
    }

    useEffect(() => {
        const getAmount = async () => {
            try {
                let jwt_token
                if (jwt) {
                    jwt_token = jwt
                    localStorage.setItem('jwt', jwt)
                } else {
                    jwt_token = localStorage.getItem('jwt')
                }
                const scrt = secret ? secret : localStorage.getItem('secret')
                const result = await getAmountSelection({ jwt_token, scrt })
                if (result.data && result.data.status === 'error') {
                    dispatch(setPageError(result.data.message))
                    dispatch(openModal())
                    if (result.data.message === 'Login expired! Please re-login.') {
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('lastVisitedPage');
                        const phone = localStorage.getItem('phone')
                        localStorage.clear()
                        phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    }
                } else if (result.data && result.data.message === 'Login expired! Please re-login.') {
                    dispatch(setPageError(result.data.message))
                    dispatch(openModal())
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    localStorage.clear()
                    const phone = localStorage.getItem('phone')
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                } else if (result.error) {
                    if (result.error && result.error.data && result.error.data.message) {
                        dispatch(setPageError(result.error.data.message))
                    } else {
                        dispatch(setPageError('Please check your internet or try again later.'))
                    }
                    dispatch(openModal())
                } else {
                    //const bpArr = Array.from({ length: 4 }, (_, i) => Math.round(parseInt(result.data.approved_amount) / 4 * (i + 1)))
                    const bpArr = [];
                    for (let i = result.data.min_amount; i <= parseInt(result.data.approved_amount); i += result.data.step) {
                        bpArr.push(i);
                    }
                    dispatch(setAmountData({ ...result.data }))
                    dispatch(setBreakpoints(bpArr))
                    dispatch(setAmount(result.data.approved_amount))
                    setBtnDisable(false);
                }
            } catch (error) {
                dispatch(setPageError('Something went wrong. Please try again later.'));
                dispatch(openModal())
            }
        }
        getAmount()
    }, [dispatch, getAmountSelection, navigate, jwt, secret])

    const handleSubmitAmountSelection = async () => {
        try {
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret')
            const consents = [
                {
                  consent_type: "MFI_DECLARATION",
                  consent_status: isChecked ? "ACCEPTED" : "DECLINED",
                  consent_text: "I confirm that my annual household income is greater than 3 lakh."
                }
            ]
    
            const result = await submitAmountSelection({ jwt_token, amount, scrt, consents: JSON.stringify(consents) })
            if (result.data && result.data.status === 'error') {
                dispatch(setPageError(result.data.message))
                dispatch(openModal())
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                }
            } else if (result.error) {
                if (result.error && result.error.data && result.error.data.message) {
                    dispatch(setPageError(result.error.data.message))
                } else {
                    dispatch(setPageError('Please check your internet or try again later.'))
                }
                dispatch(openModal())
            } else {
                if (result && result.data && result.data.redirect_url) {
                    const event_name = 'web_soft_approval_success'
                    const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation }
                    await pushCleverTapEvent({ event_name, event_property })
                    window.location.href = result.data.redirect_url
                }
            }
        } catch (error) {
            dispatch(setPageError('Something went wrong. Please try again later.'));
            dispatch(openModal())
        }
    }

    // setting customer ID for clevertap identification.
    useEffect(() => {
        (async () => {
            let jwt_token = jwt ? jwt : localStorage.getItem('jwt');
            let scrt = secret ? secret : localStorage.getItem('secret');
            const result = await getCustomerDetails({ jwt_token, scrt });
            if(result.data?.success) {
                clevertapIdentitySet({identity: result.data?.data?.id});
            }
            if(result.error) {
               console.log(`customer_details_error <<${result.error.data.error_message}>> || error_code <<${result.error.data.error_code}>>`);
            }
        })()
    }, []);

    const handleVkycVerification = () => {
        navigate('/vkyc-verification')
    }

    return (
        <div className='external-wrapper amount-page'>
            <CenteredPopup
                isOpen={isModalOpen}
                buttons={modalButtons}
                onClose={handleClose} icon={<WarningIcon />}>
                <p>{pageerror}</p>
            </CenteredPopup>
            <div className='page-content'>
                <PageHeader />
                {/*<div className='page-heading'>
                    <h2 className='page-title'>Select the required amount</h2>
                </div>*/}
                <div className='amount-section'>
                    <h3>Approved!</h3>
                    <p>You are eligible for a Personal Loan up to</p>
                    <div className='loan-amount'>
                        <div className='amount'><span>₹</span><span>{amount ? formatCurrency(Number(amount)) : '0'}</span></div>
                        <p>Selected loan amount</p>
                        {breakpoints && breakpoints.length > 0 ? <div style={!isChecked ? {
                            filter: 'saturate(0)',
                            opacity: 0.4,
                            pointerEvents: 'none'
                        } : null}><input type="range" className='slider' min="0" max={amountdata && amountdata.approved_amount ? breakpoints.indexOf(parseInt(amountdata.approved_amount)) : 0} step="1" value={breakpoints.indexOf(parseInt(amount))} onChange={handleSliderChange} />
                            <div className='breakpoints'>
                                {/*breakpoints.map((point, index) => (
                                    <span key={index}>₹{formatCurrency(Number(point))}</span>
                                ))*/}
                                <span>₹{formatCurrency(Number(breakpoints[0]))}</span>
                                <span></span>
                                <span></span>
                                <span>₹{formatCurrency(Number(breakpoints[breakpoints.length - 1]))}</span>
                            </div></div> : null}
                        <p><span>Eligible amount ₹{amountdata && amountdata.approved_amount ? formatCurrency(Number(amountdata.approved_amount)) : ''}</span></p>
                    </div>
                    <div className='repay-wrapper'>
                        <div className='repay'><span>Repayment Period</span><span>{amountdata && amountdata.tenure ? amountdata.tenure : ''} months</span></div>
                        <div className='emi'><span>Expected EMI</span><span>₹{amountdata && amountdata.emi_amount ? formatCurrency(Number(amountdata.emi_amount)) : ''}</span></div>
                    </div>
                    <VkycCard onCompleteClick={handleVkycVerification} setIsLoading={() => {}} />
                    <div className='consent-check'><label><div className={`checkbox ${isChecked ? 'checked' : ''}`}><input type="checkbox" checked={isChecked} onChange={() => dispatch(setIsChecked(!isChecked))} /></div> <p>I confirm that my annual household income is greater than 3 lakh.</p></label></div>
                </div>
                <div className='bottom-footer p-0'>
                    <p className='powered-by'>Powered by <StarfinLogo /></p>
                    <button type="button" onClick={
                        () => {
                            //localStorage.setItem("lastVisitedPage", '/complete-your-kyc')
                            //navigate('/complete-your-kyc')
                            handleSubmitAmountSelection()
                        }
                    } className={`btn btn-primary ${!isChecked || isLoading || btnDisable ? 'disabled' : ''}`}>Continue</button>
                </div>
            </div>
        </div >
    );
}

export default AmountRequired;
